import { render, staticRenderFns } from "./CallToActionForm.vue?vue&type=template&id=10fdd064&scoped=true"
import script from "./CallToActionForm.vue?vue&type=script&lang=js"
export * from "./CallToActionForm.vue?vue&type=script&lang=js"
import style0 from "./CallToActionForm.vue?vue&type=style&index=0&id=10fdd064&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fdd064",
  null
  
)

export default component.exports